export const commStructures = [{
    commStructureId: 'C1',
    commRate: [{
        date: '2020-05-01',
        ren: 2.5,
        hot: 2.8,
        tm: 2.925,
        vp: 3.05,
    }]
}]